import React from "react";
import { createBrowserRouter } from "react-router-dom";
import HomeBasquet from "./pages/HomeBasquet";
import AdminBasquet from "./pages/AdminBasquet";
import HomeVoley from "./pages/HomeVoley";
import AdminVoley from "./pages/AdminVoley"
import Home from "./pages/Home"
const router = createBrowserRouter([
  {
    path: "/",
    element: <Home/>,
  },
  {
    path: "/basquet",
    element: <HomeBasquet />,
  },
  {
    path: "/admin-basquet",
    element: <AdminBasquet />,
  },
  {
    path: "/voley",
    element: <HomeVoley />,
  },
  {
    path: "/admin-voley",
    element: <AdminVoley />,
  },
]);

export { router };
